var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("header", { staticClass: "page_title" }, [
    _c("div", { staticClass: "container" }, [
      _vm.resolvedLogo
        ? _c("figure", [
            _c("img", {
              attrs: { src: _vm.resolvedLogo, alt: _vm.resolvedAlt },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "brand-name" }, [
              _vm._v(_vm._s(_vm.resolvedAlt)),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.title
        ? _c("h3", [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.subTitle
        ? _c("p", [_vm._v("\n      " + _vm._s(_vm.subTitle) + "\n    ")])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }